import Analytic from '@commons/cards/analytic'
import Grid from '@components/grid'

import { Fragment } from 'react/jsx-runtime'

import Title from '@components/title'
import Column from '@components/column'
import { useSelector } from 'react-redux'
import { RootState } from '@store/index'
import { Cards } from '@apis/index'
import { useEffect } from 'react'
import { totalusers } from '@assets/icons'
import { useLocation, useNavigate } from 'react-router-dom'

const DashboardCard = ({ cardConfig = [] }: { cardConfig?: any }) => {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const { data: dashboard, loading } = useSelector(
    (state: RootState) => state.dashboard,
  )
  console.log(dashboard, 'sdfsdf')
  const fetchDashboard = async () => {
    try {
      await Cards.list({ state: 'dashboard' })
    } catch (error) {}
  }

  useEffect(() => {
    fetchDashboard()
  }, [])
  return (
    <Fragment>
      <Column>
        {pathname === '/admin/dashboard' && (
          <Title textone="Welcome back," texttwo="Admin" />
        )}

        <Grid>
          {cardConfig?.map((card, i) => (
            <Analytic
              loading={loading}
              key={i}
              title={card.title}
              icon={card.icon}
              value={dashboard?.[card.key] ?? 0}
              percentChange="10"
              isUp={card.isUp}
              onClick={() => {
                navigate(card.link)
              }}
            />
          ))}
        </Grid>
      </Column>
    </Fragment>
  )
}
export default DashboardCard
